import { ShortDate, DateTime } from '../models/datetime';


/**
 * Strip off the timezone name and create a native date with the result.
 */
export function toNativeDateTime(datetime: DateTime) {
  let parts = (datetime || '').split(/\[|\]/);
  return parts.length
    ? new Date(parts[0])
    : null;
}


/**
 * Convert ISO short date (YYYY-MM-dd) to MM/dd/YYYY format.
 * @param value string in YYYY-MM-dd format
 */
export function shortDateToSlashDate(value: ShortDate) {
  let parts = (value || '').split('-');
  if (parts.length === 3) {
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  }
}


/**
 * Convert native Javascript date to `ShortDate`. ('YYYY-MM-dd' string).
 * https://stackoverflow.com/a/37661393/311207
 */
export function toShortDate(date: Date): ShortDate {
  let isoDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
  return isoDate.substring(0, 10);
}


/**
 * Subtract `numDays` from a native Javascript date.
 * https://stackoverflow.com/a/1296374/311207
 */
export function subtractDays(date: Date, numDays: number): Date {
  return new Date(new Date(date).setDate(date.getDate() - numDays));
}


/**
 * Add `numDays` to a native Javascript date.
 */
export function addDays(date: Date, numDays: number): Date {
  return new Date(new Date(date).setDate(date.getDate() + numDays));
}
